<div
  class="star percent-{{ star.percent }}"
  #el
  (click)="onClick($event)"
  (mousemove)="onMove($event)"
  (mouseover)="onOver()"
>
  <ark-icon icon="system-star" [size]="size"></ark-icon>
</div>
